<template>
  <form class="form" method="post">

    <HeaderApp />
    <div id="appCollectionVueComponent" class="appFontBlack">
      <div class="AppCollectionMenu">
        <h2>Encaissement</h2>
      </div>
      <div class="AppCollectionMenuList">
        <button @click.prevent="newClient()" type="submit" class="appButtonModel2"> Nouveau client</button>
        <button @click.prevent="collectionSlot()" type="submit" class="appButtonModel2"> Nouvel Encaissement</button>
        <button @click.prevent="collectionPaiement()" type="submit" class="appButtonModel2"> Paiement</button>
      </div>
      <br>
      <h2>Liste des encaissements en cours</h2>
      <div :key="index" v-for="(invoice, index) in filteredInvoice" class="appClientCardList appHoverEffect">
        <div @click.prevent="selectClient(invoice._id)" class="appClientCardListSelect">
          <div class="appClientCardListLine1">
            <p>{{ invoice.client }}</p>
            <p>{{ parseFloat(invoice.totalprice).toFixed(2) }} €</p>
          </div>
        </div>
      </div>
      <button @click.prevent="addDateToInvoice()" type="submit" class="appButtonModel2"> Compléter / Visualiser une facture</button>
    </div>

  </form>
</template>

<script>
import HeaderApp from '../Application/HeaderApp.vue'
import axios from 'axios'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'AppCollectionMenu',
  data () {
    return {
      invoice: ''
    }
  },
  updated () {
    this.listInvoicesCode1()
  },
  mounted () {
    this.listInvoicesCode1()
  },
  computed: {
    filteredInvoice () {
      if (this.invoice.length > 0) {
        return this.invoice.filter(item => item.categoryOfInvoice === 1)
      }
    }
  },
  methods: {
    listInvoicesCode1 () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.invoice = response.data
        })
    },
    collectionSlot () {
      this.$router.push('/App/Collection/Select')
    },
    newClient () {
      this.$router.push('/App/Clients/Create')
    },
    selectClient (id) {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/factures/' + id), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.invoice = response.data
          let idClient = response.data.userId
          let mySelectionSettings = []
          const cartLines = JSON.stringify(response.data.lines)
          const cartSetting =
        {
          statut: 'Modification',
          factureId: response.data._id,
          reduction: response.data.reduction,
          technicalData: response.data.technicalData
        }
          mySelectionSettings.push(cartSetting)
          localStorage.setItem('orderPrivilegiaSettings', JSON.stringify(mySelectionSettings))
          localStorage.setItem('orderPrivilegia', cartLines)
          this.$router.push('/App/Collection/Slot?id=' + idClient)
        })
    },
    collectionPaiement () {
      this.$router.push('/App/Collection/Paiement')
    },
    addDateToInvoice () {
      this.$router.push('/App/Collection/Paiement/Reedition')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppCollection.vue